// Copyright (c) 2024. Sendanor <info@sendanor.fi>. All rights reserved.

import {
    explainEnum,
    isEnum,
    parseEnum,
    stringifyEnum,
} from "../../../../io/hyperify/core/types/Enum";
import {
    explainNot,
    explainOk,
    explainOr,
} from "../../../../io/hyperify/core/types/explain";
import { isUndefined } from "../../../../io/hyperify/core/types/undefined";

export enum SendanorIcon {
    ImagesIcon = "ImagesIcon",
    PremiumDomainIcon = "PremiumDomainIcon",
    InternetIcon = "InternetIcon",
    SupportIcon = "SupportIcon",
    ShoppingCartIcon = "ShoppingCartIcon",
    TrashIcon = "TrashIcon",
    SignInIcon = "SignInIcon",
    SignOutIcon = "SignOutIcon",
    MenuIcon = "MenuIcon",
    WebHotelsIcon = "WebHotelsIcon",
    VirtualServersIcon = "VirtualServersIcon",
    DomainsIcon = "DomainsIcon",
    ShellsIcon = "ShellsIcon",
    DatabasesIcon = "DatabasesIcon",
    EmailIcon = "EmailIcon",
    WebrtcIcon = "WebrtcIcon",
    WordpressIcon = "WordpressIcon",
    SearchIcon = "SearchIcon",
    OutletIcon = "OutletIcon",
}

export function isSendanorIcon (value: unknown) : value is SendanorIcon {
    return isEnum(SendanorIcon, value);
}

export function explainSendanorIcon (value : unknown) : string {
    return explainEnum("SendanorIcon", SendanorIcon, isSendanorIcon, value);
}

export function stringifySendanorIcon (value : SendanorIcon) : string {
    return stringifyEnum(SendanorIcon, value);
}

export function parseSendanorIcon (value: any) : SendanorIcon | undefined {
    return parseEnum(SendanorIcon, value) as SendanorIcon | undefined;
}

export function isSendanorIconOrUndefined (value: unknown): value is SendanorIcon | undefined {
    return isUndefined(value) || isSendanorIcon(value);
}

export function explainSendanorIconOrUndefined (value: unknown): string {
    return isSendanorIconOrUndefined(value) ? explainOk() : explainNot(explainOr(['SendanorIcon', 'undefined']));
}
